import { TeamAvatar } from 'components/Image/TeamAvatar';
import { ArrowRight } from 'components/Svg/ArrowRight';
import Link from 'next/link';
import { type PlayerProfilePageProps } from 'pages/db/[id]';

import styles from './CollegeDraft.module.scss';

interface CollegeDraftProps {
  playerProfile: PlayerProfilePageProps['playerProfile'];
}

export const CollegeDraft = ({ playerProfile }: CollegeDraftProps) => {
  const { draft } = playerProfile;

  const league = draft?.sportKey === 1 ? 'NFL' : 'NBA';
  const draftYear = draft?.year ?? new Date().getFullYear();
  const draftLink =
    draft?.sportKey === 1
      ? `/nfl/draft/${draftYear}`
      : `/nba/draft/${draftYear}`;

  return (
    <section className={styles.block}>
      <h2 className={styles.item}>
        <span>{draft?.year}</span>
        <span className={styles.label}>{league} Draft</span>
      </h2>
      <div className={styles.teams}>
        <div className={styles.item}>
          <TeamAvatar
            height={50}
            slug={draft?.collegeOrganization?.slug}
            src={draft?.collegeOrganization?.assetUrl}
            width={50}
          />
        </div>
        <ArrowRight className={styles.arrow} />
        <div className={styles.item}>
          <TeamAvatar
            height={50}
            slug={draft?.organization?.slug}
            src={draft?.organization?.assetUrl}
            width={50}
          />
        </div>
      </div>
      <div className={styles.details}>
        <div className={styles.item}>
          <span className={styles.label}>Round</span>
          <span className={styles.value}>{draft?.round}</span>
        </div>
        <div className={styles.item}>
          <span className={styles.label}>Pick</span>
          <span className={styles.value}>{draft?.pick}</span>
        </div>
        <div className={styles.item}>
          <span className={styles.label}>OverAll</span>
          <span className={styles.value}>{draft?.overallPick}</span>
        </div>
      </div>
      <div className={styles.view}>
        <Link href={draftLink}>
          Complete Draft
          <ArrowRight className={styles.arrow} fill="currentColor" />
        </Link>
      </div>
    </section>
  );
};
